import React from 'react';
import _ from 'lodash';
import {Elements} from './../components/ScreenElements/Elements'
import LiveExperimentComponent from './../components/LiveExperiment';
import ExperimentDetails from './../components/ExperimentDetails';
import LiveExperiment from './LiveExperiment';

import Template from './templates/Template.js'

import Papa from 'papaparse'

export default class Experiment{
	constructor(app, component){
		this.app = app;
		this.component = component;
		this.data = {};
		this.selectedScreens = [];
		this.selectedElements = [];
		this.selectScreen = this.selectScreen.bind(this);
		this.skipClick = false;
		this.onScreenDropParams = {};
		this.debouncedSave = _.debounce(this.save.bind(this), 2000);
	}

	get dataSetIds() {
		return _.sortBy(this.data.dataSets.map(dataSet => dataSet.id));
	}

	openAddScreenDialog(){
		this.app.openDialog({label:"Add a screen", Component:AddScreenDialog, width:'530px'});
	}

	showLeftRailContextMenu({event, parent, screen, node}){
		if(event.altKey){return;}
		event.preventDefault();
		event.stopPropagation();
		
		if(screen === this.data.screens){
			return;
		}

		const options = [
			{label:'Duplicate', onClick: () => { let screenCopy = _.cloneDeep(screen); screenCopy.id += ' (Copy)';  parent.splice(parent.indexOf(screen) + 1, 0, screenCopy); this.app.closeContextMenu(); } },
			{label:'Delete', onClick: () => { _.pull(parent, screen); this.selectedScreens=[]; this.app.closeContextMenu(); } }
		];

		let selectedScreens = this.getSelectedScreensWithoutRoot();

		if(selectedScreens.length >= 1){
			options.unshift({
				label:'Group Selected', 
				onClick: () => { 
					const parent = this.getScreenParent(selectedScreens[0]);
					let indexOfFirst = parent.children.indexOf(selectedScreens[0]); 

					let allScreens = this.getFlattenedScreens(this.data.screens);
					const sortedScreens = _.sortBy(selectedScreens, (screen) => allScreens.indexOf(screen));
					let removes = selectedScreens.map( screen => { let parent1 = this.getScreenParent(screen); return () => { _.pull(parent1.children, screen);} });
					let newGroup = {id:'New Group', isGroup:true, children:[...sortedScreens]} ;
					parent.children.splice(indexOfFirst, 0, newGroup); 
					removes.forEach( remove => remove() );
					this.app.closeContextMenu();
				}
			});
		}

		this.app.showContextMenu({ anchorEl:node, options });

		this.forceUpdate();

	}

	showElementContextMenu({event, element}){
		if(event.altKey){return;}
		event.preventDefault();
		event.stopPropagation();

		const options = [
			{label:<div className="keyboard-shortcut-item">Bring to front <span className="keyboard-shortcut">Shift+&uarr;</span></div>, onClick: () => { this.moveElements({position:'top', elements:this.selectedElements}); this.app.closeContextMenu();}},
			{label:<div className="keyboard-shortcut-item">Bring forward <span className="keyboard-shortcut">Ctrl+&uarr;</span></div>, onClick: () => { this.moveElements({position:'up', elements:this.selectedElements}); this.app.closeContextMenu();}},
			{label:<div className="keyboard-shortcut-item">Send backward <span className="keyboard-shortcut">Ctrl+&darr;</span></div>, onClick: () => { this.moveElements({position:'down', elements:this.selectedElements}); this.app.closeContextMenu();}},
			{label:<div className="keyboard-shortcut-item">Send to back <span className="keyboard-shortcut">Shift+&darr;</span></div>, onClick: () => { this.moveElements({position:'bottom', elements:this.selectedElements}); this.app.closeContextMenu();}},
		];

		this.app.showContextMenu({ anchorEl:event.currentTarget, options });
		this.forceUpdate();

	}

	getSelectedScreensWithoutRoot(){
		return _.without(this.selectedScreens, this.data.screens);
	}

	getScreenParent(screen){
		return LiveExperiment.getScreenParent(screen, this.data.screens);
	}

	removeScreen(screen){
		_.pull(this.getScreenParent(screen).children, screen);
	}

	addBlankScreen(){
		let newScreen = {id:'New Blank Screen'};
		this.data.screens.children.push(newScreen);
		this.app.closeDialog();
		this.selectScreen(newScreen);
		setTimeout(()=>{ 
			document.querySelector('#screen-id-input').focus(); 
			document.querySelector('#screen-id-input').select();
		}, 500);
	}

	async addFromTemplate(TemplateClass){
		const template = new Template(TemplateClass, this.app);
		const newScreens = await template.getScreens();
		this.data.screens.children.push(...newScreens);
		this.selectFirstScreen({isGroup:true, children:newScreens});
		this.app.closeDialog();
	}

	addElement(type, file=null){
		this.currentScreen.elements  = this.currentScreen.elements || [];
		let newElement = _.cloneDeep(Elements[type].defaultJSON);

		let x = this.data.width / 2 - newElement.width/2;
		let y = this.data.height / 2 - newElement.height/2;

		const offset = _.uniqueId() % 10 * 10;

		newElement.x = x + offset;
		newElement.y = y + offset;

		if(_.has(newElement, 'url') && file){
			newElement.url = file.id;
		}

		this.currentScreen.elements.push(newElement);
		this.selectedElements = [newElement];
		this.forceUpdate();
	}

	center({elements, horizontal = false, vertical = false}){
		elements.forEach(element => {
			let x = this.data.width / 2 - element.width/2;
			let y = this.data.height / 2 - element.height/2;
			if(horizontal){ element.x = x; }
			if(vertical){ element.y = y; }
		})
	}

	getUniqueDataSetName(name){
		const groupedById = _.groupBy(this.app.experiment.data.dataSets, 'id');
		return name + '-' + _.get(groupedById, name, []).length;
	}

	deleteDataSet(dataSet){
		if(window.confirm('Are you sure you want to delete this dataset?')){
			_.pull(this.data.dataSets, dataSet); 
			this.forceUpdate();
		}
	}

	replaceElement(type, file=null){
		this.currentElement.url = file.id;
		this.forceUpdate();
	}


	forceUpdate(){
		this.component.forceUpdate();
	}

	getViewStateFromCurrentScreen(){
		let currentScreen = this.currentScreen;
		return {
			isScreen: (currentScreen && !currentScreen.isGroup),
			isGroup: (currentScreen && currentScreen.isGroup),
			isMultiple: !currentScreen,
		};
	}

	isSelectedScreen(screen){
		return this.selectedScreens.includes(screen);
	}

	selectScreen(screen, appendToSelection){
		if(this.selectedScreens.includes(screen)){
			if(appendToSelection){
				_.remove(this.selectedScreens, screen);
			}else{
				this.selectedScreens = [];
			}
		}else{
			if(appendToSelection){
				this.selectedScreens.push(screen);
			}else{
				this.selectedScreens = [screen];
			}
		}
		this.selectedElements = [];
	}



	moveElements({position, elements}){
		let sortedElements = _.sortBy(elements, element => this.currentScreen.elements.indexOf(element));

		let usedIndices = {};

		if(position === 'down'){
			sortedElements.forEach(element => {
				let newIndex = Math.max(this.currentScreen.elements.indexOf(element) - 1, 0);
				if(!usedIndices[newIndex]){
					_.pull(this.currentScreen.elements, element);
					this.currentScreen.elements.splice(newIndex, 0, element);
					usedIndices[newIndex] = true;
				}
			});
		}

		if(position === 'bottom'){
			_.pull(this.currentScreen.elements, ...sortedElements);
			this.currentScreen.elements.splice(0, 0, ...sortedElements);
		}

		if(position === 'top'){
			_.pull(this.currentScreen.elements, ...sortedElements);
			this.currentScreen.elements.push(...sortedElements);
		}

		sortedElements.reverse();

		if(position === 'up'){
			sortedElements.forEach(element => {
				let newIndex = Math.min(this.currentScreen.elements.indexOf(element) + 1, this.currentScreen.elements.length - 1);
				if(!usedIndices[newIndex]){
					_.pull(this.currentScreen.elements, element);
					this.currentScreen.elements.splice(newIndex, 0, element);
					usedIndices[newIndex] = true;
				}
			});
		}

		this.forceUpdate();
	}
	
	selectFirstScreen(node = this.data.screens){
		let allScreens = this.getFlattenedScreens(node);
		let firstNonGroupScreen = allScreens.find(screen => !screen.isGroup);
		if(firstNonGroupScreen){
			this.selectScreen(firstNonGroupScreen);
		}
	}

	getFlattenedScreens(node){
		return _.compact(_.flatten([node].concat(_.map(node.children, child => this.getFlattenedScreens(child)))));
	}

	get currentScreen(){
		if(this.selectedScreens.length === 1){
			return this.selectedScreens[0];
		}
		return null;
	}

	get currentDataSet(){

		let currentScreen = this.currentScreen;
		if( currentScreen && currentScreen.useDataSet && currentScreen.dataSetId ) {
			return this.data.dataSets.find( dataSet => dataSet.id === currentScreen.dataSetId);
		}
		return null;
	}

	isSelectedElement(element){
		return this.selectedElements.includes(element);
	}

	selectElement(element, appendToSelection){
		if(this.selectedElements.includes(element)){
			if(appendToSelection){
				_.remove(this.selectedElements, element);
			}else{
				//this.selectedElements = [];
			}
		}else{
			if(appendToSelection){
				this.selectedElements.push(element);
			}else{
				this.selectedElements = [element];
			}
		}
	}

	get currentElement(){
		if(this.selectedElements.length === 1){
			return this.selectedElements[0];
		}
		return null;
	}

	save(){
		this.app.builderForm.submit();
		//this.app.localStorage('experiment', this.data);
	}

	preview(){
		this.app.liveExperiment && this.app.liveExperiment.reset();
		this.app.openFullScreenDialog({label:'Preview Experiment', Component: () => <LiveExperimentComponent preview app={this.app} experimentData={this.data} />})
	}

	showDetails(){
		this.detailsTemp = _.cloneDeep(this.details);
		this.app.openFullScreenDialog({label:'Publish Details', hideClose:true, Component: () => <ExperimentDetails />})
	}

	attemptToSaveDetails(){
		let experimentEntity = this.detailsTemp;

		let errors = false;

		experimentEntity.rules.forEach( (rule, i) => {
			if(rule.operator === "within"){
				delete rule.value;
				if(rule.min === '' || rule.max === ''){
					errors = true;
				}
				return;
			}

			if(rule.operator === "any"){
				delete rule.value;
				return;
			}

			if(rule.value === ''){
				errors = true;
			}
		});

		if(errors){
			this.app.showFlashMessage({label:'Error: Rules are not complete - each rule needs a value.', color:'red'});
			return;
		}

		experimentEntity.rules = _.compact(experimentEntity.rules);
		this.details = experimentEntity;
		this.save();
		this.app.closeFullScreenDialog();
	}

	manageDatasets(){
		this.app.openFullScreenDialog({label:'Manage Datasets', Component: () => <div>Coming soon.</div> })
	}

	get hasChanges(){
		return JSON.stringify(this.details) !== this.lastSaved;
	}

	downloadDataSet(dataSet){
		const data = Papa.unparse(dataSet.rows);
		downloadFile({
			data: data,
			filename:'DataSet.csv',
			mime:'text/csv',
		});
	}

	copyDataSetToClipboard(){
		return Papa.unparse(this.currentDataSet.rows);
	}

	recordEvent(){
		// Don nothing when the builder tries to record an event.
	}

	uploadFile(){
		const fileInput = document.querySelector('.datasetInput');
		Papa.parse(fileInput.files[0], {
			skipEmptyLines: true,
			complete: (results) => {
				if(results.errors.length === 0){
					this.currentDataSet.rows = results.data;
					fileInput.value = '';
					this.forceUpdate();
				}else{
					alert('Failed to import file:\n' + JSON.stringify(results.errors, null, '\t'));
				}
			}
		});
	}
}


/*

async function getBase64(file) {
	return new Promise( (resolve, reject) => {
		var reader = new FileReader();
		reader.onload = function () {
			//console.log(reader.result);
			resolve(reader.result)
		};
		reader.onerror = function (error) {
			//console.log('Error: ', error);
			reject(error);
		};
		reader.readAsDataURL(file);
	});
 }


 var file = document.querySelector('#files > input[type="file"]').files[0];
 getBase64(file); // prints the base64 string



 function handleImage(e){
    var reader = new FileReader();
    reader.onload = function(event){
        var img = new Image();
        img.onload = function(){
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.drawImage(img,0,0);
        }
        img.src = event.target.result;
    }
    reader.readAsDataURL(e.target.files[0]);     
}

function previewFile() {
	var preview = document.querySelector('img');
	var file    = document.querySelector('input[type=file]').files[0];
	var reader  = new FileReader();
  
	reader.onloadend = function () {
	  preview.src = reader.result;
	}
  
	if (file) {
	  reader.readAsDataURL(file);
	} else {
	  preview.src = "";
	}
  }
*/



const AddScreenDialog = (props) => (
	<div style={{display: 'flex', flexWrap:'wrap'}}>
		<div className="AddScreen-screen-button" onClick={ (e)=> props.experiment.addBlankScreen() }>
			Blank Screen
		</div>
		<TemplateThumbnail label="User Acceptance" type="UserAgreementTemplate" experiment={props.experiment} />
		<TemplateThumbnail label="Image Loop" type="ImageLoopTemplate" experiment={props.experiment} />
		
	</div>
)

const TemplateThumbnail = ({experiment, label, type}) => (
	<div className="AddScreen-screen-button" onClick={ (e)=> experiment.addFromTemplate(type) }>
		{label}
	</div>
);

// https://github.com/kennethjiang/js-file-download/blob/master/file-download.js MIT License.
function downloadFile({data, filename, mime}) {
	var blob = new Blob([data], {type: mime || 'application/octet-stream'});
	if (typeof window.navigator.msSaveBlob !== 'undefined') {
		// IE workaround for "HTML7007: One or more blob URLs were 
		// revoked by closing the blob for which they were created. 
		// These URLs will no longer resolve as the data backing 
		// the URL has been freed."
		window.navigator.msSaveBlob(blob, filename);
	}
	else {
		var blobURL = window.URL.createObjectURL(blob);
		var tempLink = document.createElement('a');
		tempLink.style.display = 'none';
		tempLink.href = blobURL;
		tempLink.setAttribute('download', filename); 
		
		// Safari thinks _blank anchor are pop ups. We only want to set _blank
		// target if the browser does not support the HTML5 download attribute.
		// This allows you to download files in desktop safari if pop up blocking 
		// is enabled.
		if (typeof tempLink.download === 'undefined') {
			tempLink.setAttribute('target', '_blank');
		}
		
		document.body.appendChild(tempLink);
		tempLink.click();
		document.body.removeChild(tempLink);
		window.URL.revokeObjectURL(blobURL);
	}
}



// WEBPACK FOOTER //
// ./src/models/Experiment.js